import { fontWeightBold } from '@/constants'
import { faHexagonExclamation } from '@fortawesome/pro-light-svg-icons'
import { Typography } from '@mui/material'

import type { NotificationTemplateProps } from '../NotificationCard.templates'
import { NotificationAction } from '../NotificationCard.utils'
import NotificationShell from '../NotificationShell'

export default function BasketAnalysisFailedNotification({
	notification,
	variant,
	type,
	onAction = () => {},
	onClose,
	onToggleRead,
	...rest
}: NotificationTemplateProps) {
	return (
		<NotificationShell
			icon={faHexagonExclamation}
			iconColor="error.main"
			notification={notification}
			variant={variant}
			onClose={onClose}
			onToggleRead={onToggleRead}
			{...rest}
		>
			<Typography variant="body1" color="error" fontWeight={fontWeightBold}>
				{notification.title}
			</Typography>

			{notification.description && (
				<Typography variant="body2" color="text.secondary">
					{notification.description}
				</Typography>
			)}

			{notification.actions.map((action) => (
				<NotificationAction
					key={JSON.stringify(action)}
					notification={notification}
					action={action}
					onAction={onAction}
				/>
			))}
		</NotificationShell>
	)
}
